.modal-hug-content {
  padding: var(--rc-theme-spacing-lg);
}
